import { Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { PropertyOwnerType, PropertyType, DocumentCategory } from '../app/models/declarations';
import { PropertyCardModel } from './models/propertyCardModel';
import { PropertyOwnerModel } from './models/propertyOwnerModel';
import { MailRequest, MailRequestEx } from './models/mailRequest';
import { CardBearerModel } from './models/cardBearerModel';
import { DocumentViewRequest } from './models/documentViewRequest';
import { WhatsappRequest } from './models/whatsappRequest';
import { PropertyDocumentModel } from './models/PropertyDocumentModel';


@Injectable({
  providedIn: 'root'
})
export class DataService {

  public _PropertyOwnerTypes: Array<PropertyOwnerType>;
  public get PropertyOwnerTypes(): Array<PropertyOwnerType> {
    this._PropertyOwnerTypes = JSON.parse(localStorage.getItem("_PropertyOwnerTypes"));
    return this._PropertyOwnerTypes;
  }
  public set PropertyOwnerTypes(val: Array<PropertyOwnerType>) {
    localStorage.setItem("_PropertyOwnerTypes", JSON.stringify(val));
    this._PropertyOwnerTypes = val;
  }


  public _PropertyTypes: Array<PropertyType>;
  public get PropertyTypes(): Array<PropertyType> {
    this._PropertyTypes = JSON.parse(localStorage.getItem("_PropertyTypes"));
    return this._PropertyTypes;
  }
  public set PropertyTypes(val: Array<PropertyType>) {
    localStorage.setItem("_PropertyTypes", JSON.stringify(val));
    this._PropertyTypes = val;
  }


  public _DocumentCategories: Array<DocumentCategory>;
  public get DocumentCategories(): Array<DocumentCategory> {
    this._DocumentCategories = JSON.parse(localStorage.getItem("_DocumentCategories"));
    return this._DocumentCategories;
  }
  public set DocumentCategories(val: Array<DocumentCategory>) {
    localStorage.setItem("_DocumentCategories", JSON.stringify(val));
    this._DocumentCategories = val;
  }



  //private _token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2MDYxMjE3NDgsImlkIjoiNWYwZGE1MzVjYTdmYWU2YzA0ZjE5YTNmIiwib3JpZ19pYXQiOjE2MDQzMjE3NDgsInJvbGUiOiJjYXJkYmVhcmVyIiwidWlkIjoiNWYwZGE1MzVjYTdmYWU2YzA0ZjE5YTNmIn0.AvGbv8zrFMVHNCHfEHIdORdiwqaQ63DVoB10cBC8R-g';
  private _token = '';

  public get token(): string {
    this._token = localStorage.getItem("_token");
    return this._token;
  }

  public set token(val: string) {
    localStorage.setItem("_token",val);
    this._token = val;
  }


  //public token: string = "";

  private _showBackButton = false;
  public get showBackButton(): boolean {
    this._showBackButton = JSON.parse(localStorage.getItem("_showBackButton"));
    return this._showBackButton;
  }
  public set showBackButton(val: boolean) {
    localStorage.setItem("_showBackButton", JSON.stringify(val));
    this._showBackButton = val;
  }



  private _backPath = '';
  public get backPath(): string {
    this._backPath = localStorage.getItem("_backPath");
    return this._backPath;
  }
  public set backPath(val: string) {
    localStorage.setItem("_backPath",val);
    this._backPath = val;
  }


  private _SelectedProperty: PropertyCardModel;
  public get SelectedProperty(): PropertyCardModel {
    this._SelectedProperty = JSON.parse(localStorage.getItem("_SelectedProperty"));
    return this._SelectedProperty;
  }
  public set SelectedProperty(val: PropertyCardModel) {
    localStorage.setItem("_SelectedProperty",JSON.stringify(val));
    this._SelectedProperty = val;
  }

  /*
  public SelectedCardNumber : string = "";
  public SelectedCardBearerID : string = "";
  */

  private _SelectedCardNumber = '2609195710121958';
  public get SelectedCardNumber() {
    this._SelectedCardNumber = localStorage.getItem("_SelectedCardNumber");
    return this._SelectedCardNumber;
  }
  public set SelectedCardNumber(value) {
    localStorage.setItem("_SelectedCardNumber",value);
    this._SelectedCardNumber = value;
  }


  private _SelectedCardBearerID = 'murt1005';
  public get SelectedCardBearerID() {
    this._SelectedCardBearerID = localStorage.getItem("_SelectedCardBearerID");
    return this._SelectedCardBearerID;
  }
  public set SelectedCardBearerID(value) {
    localStorage.setItem("_SelectedCardBearerID",value);
    this._SelectedCardBearerID = value;
  }


  //public SelectedCardNumber = '1508196326121963';
  //public SelectedCardBearerID = 'rush0109';

  private _SelectedCardBearer: CardBearerModel;
  public get SelectedCardBearer(): CardBearerModel {
    this._SelectedCardBearer = JSON.parse(localStorage.getItem("_SelectedCardBearer"));
    return this._SelectedCardBearer;
  }
  public set SelectedCardBearer(value: CardBearerModel) {
    localStorage.setItem("_SelectedCardBearer",JSON.stringify(value));
    this._SelectedCardBearer = value;
  }

  private _SelectedOwner: PropertyOwnerModel;
  public get SelectedOwner(): PropertyOwnerModel {
    this._SelectedOwner = JSON.parse(localStorage.getItem("_SelectedOwner"));
    return this._SelectedOwner;
  }
  public set SelectedOwner(value: PropertyOwnerModel) {
    localStorage.setItem("_SelectedOwner",JSON.stringify(value));
    this._SelectedOwner = value;
  }


  private _SelectedPropertyDocument: PropertyDocumentModel;
  public get SelectedPropertyDocument(): PropertyDocumentModel {
    this._SelectedPropertyDocument = JSON.parse(localStorage.getItem("_SelectedPropertyDocument"));
    return this._SelectedPropertyDocument;
  }
  public set SelectedPropertyDocument(value: PropertyDocumentModel) {
    localStorage.setItem("_SelectedPropertyDocument",JSON.stringify(value));
    this._SelectedPropertyDocument = value;
  }


  
  private _SelectedDocumentCategory: DocumentCategory;
  public get SelectedDocumentCategory(): DocumentCategory {
    this._SelectedDocumentCategory = JSON.parse(localStorage.getItem("_SelectedDocumentCategory"));
    return this._SelectedDocumentCategory;
  }
  public set SelectedDocumentCategory(value: DocumentCategory) {
    localStorage.setItem("_SelectedDocumentCategory",JSON.stringify(value));
    this._SelectedDocumentCategory = value;
  }




  public _MailReq: MailRequest;
  public get MailReq(): MailRequest {
    this._MailReq = JSON.parse(localStorage.getItem("_MailReq"));
    return this._MailReq;
  }
  public set MailReq(value: MailRequest) {
    localStorage.setItem("_MailReq",JSON.stringify(value));
    this._MailReq = value;
  }


  public _MailReqEx: MailRequestEx;
  public get MailReqEx(): MailRequestEx {
    this._MailReqEx = JSON.parse(localStorage.getItem("_MailReqEx"));
    return this._MailReqEx;
  }
  public set MailReqEx(value: MailRequestEx) {
    localStorage.setItem("_MailReqEx",JSON.stringify(value));
    this._MailReqEx = value;
  }



  public _WhatsappReq: WhatsappRequest;
  public get WhatsappReq(): WhatsappRequest {
    this._WhatsappReq = JSON.parse(localStorage.getItem("_WhatsappReq"));
    return this._WhatsappReq;
  }
  public set WhatsappReq(value: WhatsappRequest) {
    localStorage.setItem("_WhatsappReq",JSON.stringify(value));
    this._WhatsappReq = value;
  }



  public _ActiveDocumentViewRequest: DocumentViewRequest;
  public get ActiveDocumentViewRequest(): DocumentViewRequest {
    this._ActiveDocumentViewRequest = JSON.parse(localStorage.getItem("_ActiveDocumentViewRequest"));
    return this._ActiveDocumentViewRequest;
  }
  public set ActiveDocumentViewRequest(value: DocumentViewRequest) {
    localStorage.setItem("_ActiveDocumentViewRequest",JSON.stringify(value));
    this._ActiveDocumentViewRequest = value;
  }




  public _SelectedPhoto: string;
  public get SelectedPhoto(): string {
    this._SelectedPhoto = localStorage.getItem("_SelectedPhoto");
    return this._SelectedPhoto;
  }

  public set SelectedPhoto(val: string) {
    localStorage.setItem("_SelectedPhoto",val);
    this._SelectedPhoto = val;
  }


  private _isLoggedIn: boolean = true;
  public get isLoggedIn(): boolean {
    this._isLoggedIn = JSON.parse(localStorage.getItem("_isLoggedIn"));
    return this._isLoggedIn;
  }
  public set isLoggedIn(value: boolean) {
    localStorage.setItem("_isLoggedIn",JSON.stringify(value));
    this._isLoggedIn = value;
  }

  //private _endpoint = "http://localhost:8080/"
  private _endpoint = 'https://api.aayaan.in/';
  private _searchpoint = 'https://search.aayaan.in/api/OCR/SearchDocument';


  public get endPoint() : string {
    return this._endpoint;
  }



  private _events: Subject<string> = new Subject<string>();
  public readonly events: Observable<string> = this._events.asObservable();

  public RaiseEvent(event: string) {
    this._events.next(event);
  }

  constructor(private http: HttpClient) {
    console.log('===============new instance of service created');
  }

  public request<T>(endpoint: string, data: any, method: string): Observable<T> {

    var options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': "Bearer " + this.token,
      })
    }

    console.log(options);
    switch (method) {
      case "GET": {
        return this.http.get<T>(this._endpoint + endpoint, options);
      }
      case "GETB": {
        return this.http.get<T>(endpoint, options);
      }

      case "POST": {
        return this.http.post<T>(this._endpoint + endpoint, data, options);
      }
      case "PUT": {
        return this.http.put<T>(this._endpoint + endpoint, data, options);
      }
      case "DELETE": {
        return this.http.delete<T>(this._endpoint + endpoint, options);
      }
    }

  }


  public search_request<T>(data: any, method: string): Observable<T> {

    var options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': "bearer " + this.token,
      })
    }

    console.log(options);
    switch (method) {
      case 'GET': {
        return this.http.get<T>(this._searchpoint, options);
      }
      case 'POST': {
        return this.http.post<T>(this._searchpoint, data, options);
      }
      case 'PUT': {
        return this.http.put<T>(this._searchpoint, data, options);
      }
      case 'DELETE': {
        return this.http.delete<T>(this._searchpoint, options);
      }
    }

  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }
}
